import React, { ReactNode } from 'react';
import { ThemeProvider } from './ThemeContext';
import { NotificationProvider } from './NotificationContext';
import { LoadingProvider } from './LoadingContext';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <LoadingProvider>
          {children}
        </LoadingProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
};
